import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const getInitialData = () => {
  const saved = sessionStorage.getItem('confirmation_backup');
  return saved ? JSON.parse(saved) : null;
};

const getInitialIsSingleOrder = () => {
  const saved = sessionStorage.getItem('confirmation_is_single');
  return saved !== null ? JSON.parse(saved) : false;
};

const orderSlice = createSlice({
  name: 'order',
  initialState: {
    confirmationData: getInitialData(),
    isSingleOrder: getInitialIsSingleOrder()
  },
  reducers: {
    setOrderConfirmation: (state, action: PayloadAction<unknown>) => {
      state.confirmationData = action.payload;
      sessionStorage.setItem(
        'confirmation_backup',
        JSON.stringify(action.payload)
      );
    },
    setIsSingleOrder: (state, action: PayloadAction<boolean>) => {
      state.isSingleOrder = action.payload;
      sessionStorage.setItem(
        'confirmation_is_single',
        JSON.stringify(action.payload)
      );
    },
    clearOrderData: (state) => {
      state.confirmationData = null;
      state.isSingleOrder = false;
      sessionStorage.removeItem('confirmation_backup');
      sessionStorage.removeItem('confirmation_is_single');
    }
  }
});

export const { setOrderConfirmation, setIsSingleOrder, clearOrderData } =
  orderSlice.actions;
export default orderSlice.reducer;
